import styled, { css } from "styled-components";
import breakpoint from "../../../utils/breakpoint";
import getBorderRadius from "../../../utils/getBorderRadius";
import getColor from "../../../utils/getColor";
import { getCustomColor } from "../../../utils/getCustomColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import PushOrg from "../../organisms/PushOrg";
import LinkQuark from "../../quarks/Link";
export var Icon = styled(PushOrg).withConfig({
  componentId: "sc-1nzah6x-0"
})(function (_ref) {
  var $isActive = _ref.$isActive,
    $hasDarkMode = _ref.$hasDarkMode;
  return css(["", " ", ""], !$isActive && $hasDarkMode ? css(["filter:brightness(0) invert(1);opacity:0.6;"]) : null, !$isActive && !$hasDarkMode ? css(["filter:brightness(0);opacity:0.5;"]) : null);
});
export var Link = styled(LinkQuark).withConfig({
  componentId: "sc-1nzah6x-1"
})(function (_ref2) {
  var $isActive = _ref2.$isActive,
    $activeColor = _ref2.$activeColor,
    $hasDarkMode = _ref2.$hasDarkMode,
    $hasFullWidth = _ref2.$hasFullWidth,
    theme = _ref2.theme;
  return css(["display:flex;align-items:center;justify-content:center;padding:", " ", ";border:", " solid transparent;min-height:", ";border-radius:", ";text-decoration:none;cursor:pointer;width:", ";", "{padding:", " ", " ", " ", ";}", ""], space(1.5), space(2), unit(1), space(7), getBorderRadius(theme, "mlarge"), !$hasFullWidth ? "fit-content" : "unset", breakpoint("large"), space(2), space(4), space(2), space(3), $isActive ? css(["border:", " solid ", ";background-color:", ";&:hover{background-color:", ";}"], unit(1), $activeColor, getCustomColor($activeColor, 0.12), getCustomColor($activeColor, 0.2)) : css(["& p{color:", ";}&:hover{background-color:", ";", "{opacity:", ";}& p{color:", ";}}"], $hasDarkMode ? getColor(theme, "white", "default", 0.6) : getColor(theme, "backgroundBlack", "default", 0.5), getColor(theme, $hasDarkMode ? "white" : "backgroundBlack", "default", 0.04), Icon, $hasDarkMode ? 0.8 : 0.7, $hasDarkMode ? getColor(theme, "white", "default", 0.8) : getColor(theme, "backgroundBlack", "default", 0.7)));
});